import { useState, useEffect, Fragment } from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useAuthDataContext } from "../AuthDataProvider";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Typography, ListItem } from "@mui/material";
import FleetWebApi from "../Api/FleetWebApi";
import { NavLink } from "react-router-dom";
import Moment from "react-moment";

function LocationDetails(props) {
  const { user } = useAuthDataContext();
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [locationData, setLocationData] = useState(null);

  useEffect(() => {
    if (props.locationId) {
      FleetWebApi.getLocationData([props.locationId]).then(
        (result) => {
          setLocationData(result.response[0]);
          setIsLoaded(true);
        },
        (data_error) => {
          setError(data_error);
          setIsLoaded(true);
        }
      );
    }
  }, [props.locationId]);


  const shareeList = locationData && locationData.sharees
    ? locationData.sharees.map((shareeDetails, x) => (
      <ListItem key={x} component="div">
        <Table>
          <TableBody>
            <TableRow key={x.shareeDetails}>
              <TableCell align="center" data-th="sharee">
                {shareeDetails ? shareeDetails : null}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ListItem>
    ))
    : null;

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  } else if (locationData != null) {
    return (
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={5}>
            <h3>Location Summary</h3>
            <Paper>
              <Table classes={{ root: "reactivetable" }}>
                <TableBody>
                  {props.locationId ? (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        ID
                      </TableCell>
                      <TableCell data-th="ID">
                        {props.locationId}
                        <Tooltip title="AlertAQ" arrow placement="top">
                          <IconButton
                            size="small"
                            style={{ marginLeft: 5, padding: 1, verticalAlign: "middle" }}
                            href={`https://alertaq.com/quickportal?tab=Locations&qID=${props.locationId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Open in AlertAQ"
                          >
                            <img src="/aq_logo.png" alt="AlertAQ" style={{ width: 16, height: 16, display: "block" }} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {locationData.location ? (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Name
                      </TableCell>
                      <TableCell data-th="Location Name">
                        {locationData.location}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {locationData.street ? (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Street
                      </TableCell>
                      <TableCell data-th="Street">
                        {locationData.street}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {
                    user.roles.includes("support") && locationData?.address && (
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Address
                          <Tooltip title="You can see this because you have the role: support">
                            <IconButton>
                              <HelpOutlineIcon color="secondary" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        <TableCell data-th="Address">
                          {locationData.address}
                        </TableCell>
                      </TableRow>
                    )
                  }

                  {locationData.ownerID ? (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Owner
                      </TableCell>
                      <TableCell data-th="Owner">
                        <Fragment>
                          <NavLink
                            to={"/domain/" + locationData.ownerID}
                            className="Nav_link"
                          >
                            {locationData.ownerID}
                          </NavLink>
                        </Fragment>
                      </TableCell>
                    </TableRow>
                  ) : null
                  }
                  {locationData && locationData.numSensors ? (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Number of Sensors
                      </TableCell>
                      <TableCell data-th="Number of sensors">
                        {locationData.numSensors}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {locationData && locationData.createdOn ? (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Created On
                      </TableCell>
                      <TableCell data-th="Number of sensors">
                        <Moment format="YYYY-MM-DD HH:mm:ss Z">{locationData.createdOn}</Moment>

                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
          <Grid item xs={12} md={8} lg={4}>
            {shareeList ? (
              <div>
                <h3>Sharees</h3>
                <Paper>{shareeList}</Paper>
              </div>
            ) : (
              <Typography align="center">No Sharees</Typography>
            )}
          </Grid>
        </Grid>
      </Container>
    );
  } else {
    return (
      <Paper>
        <div>Trouble Fetching Location Details</div>
      </Paper>
    )
  }
}
export default LocationDetails;
